const NotificationsManager = Marionette.Object.extend({
    _requestPermissionPromise: null,
    initialize: function(options) {
        var self = this;
        this.options = _.defaults(options || {}, {
            defaultIconUrl: ''
        });

        Backbone.Radio
            .channel('global')
            .reply('show:notification', this.showNotificaton.bind(this));

        Backbone.Radio
            .channel('global')
            .reply(
                'request:notifications:permission',
                this.requestPermission.bind(this)
            );
    },
    requestPermission: function() {
        var self = this;
        if (self._requestPermissionPromise) {
            return self._requestPermissionPromise.promise();
        } else {
            self._requestPermissionPromise = $.Deferred();
        }

        // Check if the browser supports notifications
        if (!('Notification' in window)) {
            self._requestPermissionPromise.resolve(false);
        } else if (Notification.permission === 'granted') {
            // Check whether notification permissions have already been granted
            // If okay create a notification
            self._requestPermissionPromise.resolve(true);
        } else if (Notification.permission !== 'denied') {
            // Otherwise, ask the user for permission
            Notification.requestPermission(function(permission) {
                self._requestPermissionPromise.resolve(permission === 'granted');
            });
        } else {
            self._requestPermissionPromise.resolve(false);
        }
        return self._requestPermissionPromise.promise();
    },
    showNotificaton: function(title, options) {
        var options = _.defaults(options || {}, {
            body: '',
            icon: this.options.defaultIconUrl,
            closeAfterMs: 5000,
            onClickedCallback: null
        });

        function launchNotification() {
            var n = new Notification(title, _.pick(options, 'body', 'icon'));
            n.onclick = function(event) {
                event.preventDefault();
                window.focus();
                event.currentTarget.close();
                if (options.onClickedCallback) {
                    options.onClickedCallback();
                }
            };
            setTimeout(n.close.bind(n), options.closeAfterMs);
        }

        this.requestPermission().then(function(granted) {
            if (granted) {
                launchNotification();
            }
        });
    }
});

module.exports = NotificationsManager;



/** WEBPACK FOOTER **
 ** ./assets/js/notifications-manager.js
 **/